export default __webpack_public_path__ + "static/media/team-2-800x800.3e08ef14.jpg";